/**
 * LLMコストのQuery Hook
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import { getLlmCostAuthenticated } from '@/lib/api/mise/llmCost';
import { llmCostKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * LLMコストデータを取得するQuery Hook
 * @param startDate 開始日 (YYYY-MM-DD)
 * @param endDate 終了日 (YYYY-MM-DD)
 * @param accountCode アカウントコード（省略時は全アカウント）
 */
export function useLlmCost(startDate: string, endDate: string, accountCode?: string) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: llmCostKeys.data(startDate, endDate, accountCode),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getLlmCostAuthenticated(authHeaders, {
        start_date: startDate,
        end_date: endDate,
        account_code: accountCode || undefined,
      });
    },
    enabled: !authHeaderLoading && isAuthorized && !!startDate && !!endDate,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
